import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=5083b48e&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083b48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5083b48e')) {
      api.createRecord('5083b48e', component.options)
    } else {
      api.reload('5083b48e', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=5083b48e&scoped=true", function () {
      api.rerender('5083b48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/staffManage/dialogs/Add.vue"
export default component.exports